// The backend never reveals whether an email is registered, so any answer from it ends in the neutral
// result. Only a request that never reached the backend (no response) is shown as an error.
const statusFromError = err => (err.response ? 'ok' : 'Что-то пошло не так')

export default statusFromError
